/**
 * Portal Manta · agFiltroGeo
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function agFiltroGeo(ctx, prev){
  const {kpis, baseLotes, escopoEscolhido} = ctx;
  if (!baseLotes) return {status:'idle'};
  const ufP = kpis.uf;
  const regiaoP = UF_REGIAO[ufP] || 'Sul';
  const proximas = (() => {
    const r = regiaoP;
    if (r==='Sul') return ['Sul','Sudeste'];
    if (r==='Sudeste') return ['Sudeste','Sul','Centro-Oeste'];
    if (r==='Centro-Oeste') return ['Centro-Oeste','Sudeste','Norte','Nordeste'];
    if (r==='Nordeste') return ['Nordeste','Centro-Oeste'];
    if (r==='Norte') return ['Norte','Centro-Oeste'];
    return [r];
  })();
  const filtros = {
    estado: baseLotes.filter(l => l.uf === ufP),
    regiao: baseLotes.filter(l => l.regiao === regiaoP),
    proximos: baseLotes.filter(l => proximas.includes(l.regiao)),
    todos: baseLotes,
  };
  const sugerido = filtros.estado.length>0?'estado':(filtros.regiao.length>0?'regiao':(filtros.proximos.length>0?'proximos':'todos'));
  const ativo = escopoEscolhido || sugerido;
  return {
    sub:'Filtro Geográfico',
    status:'ok',
    contagens: {estado:filtros.estado.length, regiao:filtros.regiao.length, proximos:filtros.proximos.length, todos:filtros.todos.length},
    sugerido, ativo,
    casos_ativos: filtros[ativo].length,
    msg: `Escopo "${ativo}": ${filtros[ativo].length} caso(s)`,
  };
}

export { agFiltroGeo };
export default agFiltroGeo;
